import React, { useEffect, useState } from 'react';
import { Device } from "../typings";
import { Align, Row } from "../components/Flex";
import TextField from "../components/TextField";
import { FaAngleLeft, FaAngleRight, FaSort, FaSortDown, FaSortUp } from "react-icons/fa6";
import { toast } from "react-toastify";
import { useApi } from "../api-context";
import { fetchDevices } from "./devices-api";
import DeviceRow from "./DeviceRow";

function DevicesPage() {
    const api = useApi();
    const [total, setTotal] = useState(0);
    const [devices, setDevices] = useState<Device[]>([]);

    const [page, setPage] = useState(0);
    const [nameFilter, setNameFilter] = useState('');
    const [orderBy, setOrderBy] = useState('registered');
    const [orderDirection, setOrderDirection] = useState('ASC');

    const loadDevices = (page: number, orderBy: string, orderDirection: string, nameFilter?: string) => {
        fetchDevices(api, { orderBy, orderDirection, page, nameFilter })
            .then(res => {
                setTotal(res.total);
                setDevices(res.devices);
            })
            .catch((reason) => {
                if (reason !== 'Unauthorized') {
                    toast.error('Failed to load devices');
                }
            });
    };

    const onFilter = (nameFilter: string) => {
        setPage(0);
        setNameFilter(nameFilter);
    }

    const onChangeOrder = (newOrderBy: string) => {
        setPage(0);
        if (newOrderBy === orderBy) {
            setOrderDirection(orderDirection === 'ASC' ? 'DESC' : 'ASC');
            return;
        }
        setOrderBy(newOrderBy);
        setOrderDirection('ASC')
    }

    useEffect(() => {
        loadDevices(page, orderBy, orderDirection, nameFilter || undefined);
    }, [orderBy, orderDirection, nameFilter, page]);

    const renderColumnHeader = (title: string, prop: string, flex: number) => {
        return (
            <div style={{ flex, display: 'flex' }}>
                <div className="column-header" onClick={!prop ? () => {} : () => onChangeOrder(prop)}>
                    <div>{title}</div>
                    {
                        prop && (orderBy !== prop
                            ? <FaSort/>
                            : orderDirection === 'ASC' ? <FaSortUp /> : <FaSortDown />)
                    }
                </div>
            </div>
        );
    };

    const renderSearchHeader = () => {
        return (
            <Row align={Align.SPACE_BETWEEN} className="search-header">
                <TextField label="" value={nameFilter} setValue={onFilter} placeholder="Search by ID"/>
                <div style={{ color: '#545452' }}>
                    {`Showing ${page * 10 + (total ? 1 : 0)}-${Math.min(total, (page + 1) * 10)} of ${total}`}
                </div>
            </Row>
        );
    };

    return (
        <div className="page-container drill-files-page">
            <Row gap={8} style={{marginBottom: '32px'}}>
                <div style={{ flex: 1 }} className="main-title">
                    Devices
                </div>
            </Row>
            {renderSearchHeader()}
            <Row style={{ padding: '12px 16px', marginBottom: '12px' }}>
                {renderColumnHeader('Id', 'device_id', 3)}
                {renderColumnHeader('OS', '', 1)}
                {renderColumnHeader('Registered', 'registered', 1)}
                {renderColumnHeader('Status', '', 1)}
                {renderColumnHeader('Owner', '', 3)}
                <div style={{ width: '28px' }}/>
            </Row>
            <div className="content-container" style={{ marginBottom: '32px', gap: '6px' }}>
                {devices.map((device) => (
                    <DeviceRow
                        key={device.id}
                        device={device}
                    />
                ))}
            </div>
            <Row align={Align.END} gap={4}>
                <FaAngleLeft
                    className="pager-icon"
                    onClick={() => setPage(Math.max(0, page - 1))}
                    size={20}
                    color="#545452"
                />
                <div style={{
                    fontSize: '16px',
                    fontFamily: 'InterRegular',
                    color: '#545452'
                }}>
                    {page + 1} of {Math.ceil(total / 10)}
                </div>
                <FaAngleRight
                    className="pager-icon"
                    size={20}
                    onClick={() => setPage(Math.min(Math.floor(total / 10), page + 1))}
                    color="#545452"
                />
            </Row>
        </div>
    );
}

export default DevicesPage;
